export default __webpack_public_path__ + "static/media/testimony1.12a08b13.png";